// extracted by mini-css-extract-plugin
export default {"heading":"HomepageOptions_heading__2N4bM","text":"HomepageOptions_text__9GP9x","editable-cell":"HomepageOptions_editable-cell__IXbLT","btn":"HomepageOptions_btn__PLtSG"};